import React, { useMemo } from 'react';
import MuiTable from '@root/components/table/table';
import { clamavFleetColumns } from './column';
import NoData from '@root/components/common/NoData';

const ROW_HEIGHT = 56;
const HEADER_HEIGHT = 49.9;
const WRAPPER_STYLE = { background: 'var(--accordion-background)', padding: '12px 16px' };

// Level 2: the ClamAV engine pods that make up the virus DB fleet for one scan.
// The pods are already present in the parent row (clamav_db_fleet.pods), so no
// extra request or pagination is needed here.
const ClamavFleetDetailPanel = ({ row }) => {
  const pods = useMemo(() => {
    const fleet = row?.clamav_db_fleet;
    if (!fleet?.pods?.length) return [];
    return fleet.pods.map((pod, idx) => ({ ...pod, id: `${row?.scan_id ?? 'scan'}-pod-${idx}` }));
  }, [row]);

  if (!pods.length) {
    return (
      <div className="flex h-[250px] items-center justify-center py-6 text-gray-400 text-sm" style={WRAPPER_STYLE}>
        <NoData message="No engine pods available for this scan." />
      </div>
    );
  }

  return (
    <div style={{ ...WRAPPER_STYLE, height: `${HEADER_HEIGHT + ROW_HEIGHT * pods.length + 30}px` }}>
      <MuiTable
        rows={pods}
        columns={clamavFleetColumns}
        rowHeight={ROW_HEIGHT}
        pagination={false}
        hideFooter={true}
        disableDynamicColumn={true}
        noDataMessage="No engine pods available for this scan"
      />
    </div>
  );
};

export default ClamavFleetDetailPanel;
